import styled from "styled-components";
const GameListDisplay = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-right: 10px;
  gap: 10px;
`;
export default GameListDisplay;
